import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import PrivacyPolicyContent from '../../components/Pages/PrivacyPolicy';

const { displayName } = config;

export default function PrivacyPolicy(): React.ReactElement {
  document.title = `${displayName}: Privacy Policy`;

  return (
    <Layout>
      <PrivacyPolicyContent />
    </Layout>
  );
}
